angular.module('unica_invitation.invitation_services')

.factory('InvitationCheckService', function ($http, getBaseApiURL) {

	var InvitationCheckService = {};

	InvitationCheckService.checkin = function (invitationData) {
		var url  = getBaseApiURL + '/invitation/checkin';

		return $http({
			method: 'post',
			url: url,
			data: invitationData
		}).then(function(result) {

			if ( result ) {
				return result.data;
			}

		});

	};

	return InvitationCheckService;
});